import React from 'react';
import './Footer.css'

const Footer = () => {
    return (
        <div className="bg-success">
            <div className="row d-flex">
                
           
                <div className="col-lg-12 col-sm-12  mt-2 mb-2 text-center text-white">
                    Copyright © 2021-22 | CUIGEAR | All rights reserved.
                </div>
            </div>
        </div>
    );
};

export default Footer;

/* <div className="social-icon">
<i class="fab fa-facebook-square"></i>
<i class="fab fa-instagram-square"></i>
<i class="fab fa-linkedin-in"></i>
</div> */